// Card.component.tsx
import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { DA_Tag } from "@danishagro/shared/src/components/atoms/Tag/Tag.component";
import { SSH_Buttons } from "../../../../../../components/molecules/Buttons/Buttons.component";
import { SSH_ImageViewer } from "../../../../../../components/molecules/ImageViewer/ImageViewer.component";
import { CardProps } from "./Card.interface";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./Card.module.scss";

const Card = (props: CardProps) => {
    return (
        <div className={cn(S.wrapper, props.className)}>
            {/** Image */}
            {props.image?.url ? (
                <div className={S.imageWrapper}>
                    <SSH_ImageViewer
                        src={props.image.url}
                        className={cn(S.image, { [S.verticalImage]: props.isVerticalImage })}
                        aspectRatioY={props.isVerticalImage ? 300 : 200}
                        aspectRatioX={props.isVerticalImage ? 400 : 400}
                        alternative={props.alternative}
                    />
                </div>
            ) : null}

            <div className={S.textWrapper}>
                <div className={S.textInner}>
                    {/* Tag */}
                    {props.tag && (
                        <div className={S.tagWrapper}>
                            <DA_Tag color="good">
                                <span>{props.tag}</span>
                            </DA_Tag>
                        </div>
                    )}

                    {/** Headline */}
                    {props.headline ? (
                        <DA_Title h4 tag={DA_TitleTag.H4} noMargin fullWidth>
                            {props.headline}
                        </DA_Title>
                    ) : null}

                    {/** Text */}
                    {props.text ? <DA_Text html={props.text} noPadding /> : null}
                </div>

                {/** Buttons */}
                <SSH_Buttons buttons={props.buttons} />
            </div>
        </div>
    );
};

export default Card;
